var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('w-loader'):_c('APIAutocomplete',{attrs:{"mode":"user_hold_music","value":_vm.val,"return_object":true,"before_list":_vm.before_list,"after_list":_vm.after_list,"suppress_no_items_alert":true,"data-test-id":"basic-moh-selector"},on:{"input":_vm.on_change}})
}
var staticRenderFns = []

export { render, staticRenderFns }